import { Injectable } from '@angular/core';
import { MarkerClusterService } from './marker-cluster.service';
import { IGoogleMap, ILatLng, MarkerIcon } from 'src/app/core/models/google-map-models';
import { ITrafficAlertCarkPark, CarParkTopHits } from 'src/app/core/models/models';
import { AAGoogleMarkerService } from 'src/app/modules/aa-core/services/google/google-marker/aa-google-marker.service';
import { AAGoogleIconService } from 'src/app/modules/aa-core/services/google/aa-google-icon/aagoogle-icon.service';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';
import { GoogleInfoWindowService } from '../google-info-window/google-info-window.service';
import { GoogleMapsAPIWrapperService } from '../google-map-wrapper/google-maps-api-wrapper.service';
import { GoogleMapHTTPService } from 'src/app/modules/aa-core/services/google/google-map-http/google-map-http.service';
import { AAClusterType } from '../../enums/google-map-enum';
import { GoogleMapOptionsModel } from '../../models/google-map-model';
import { EventsService } from 'src/app/core/services/events.service';
import { GoogleMapOptionsEvents } from 'src/app/core/events/events';

@Injectable({
  providedIn: 'root'
})
export class CarParkMarkerService extends MarkerClusterService {
  private carParkMarker: Array<any> = [];
  private carParkData: ITrafficAlertCarkPark[];

  constructor(
    private aaMarkerService: AAGoogleMarkerService,
    private appService: AppService,
    private eventsService: EventsService,
    private googleHttp: GoogleMapHTTPService,
    private mapsWrapper: GoogleMapsAPIWrapperService,
    private googleInfoWindow: GoogleInfoWindowService,
    private googleIconManager: AAGoogleIconService) {
    super();
    this.eventsService.on(GoogleMapOptionsEvents.CARPARK_CHANGED, this.onCarParkChanged);
    this.eventsService.on(GoogleMapOptionsEvents.CLEAR_CLRSTER_DATA, this.clearAll.bind(this));
  }

  private onCarParkChanged = (params: {googleMap: IGoogleMap, options: GoogleMapOptionsModel, reload?: boolean}): void => {
    // console.log('CarPark >>>>>>>', options, this.carParkMarker);
    this.googleInfoWindow.close();

    if (this.carParkMarker && this.carParkMarker.length && params.reload  !== true) {
      for (let markerConter = 0; markerConter < this.carParkMarker.length; markerConter++) {
        const cpMarker = this.carParkMarker[markerConter];
        cpMarker.setVisible(params.options.CarPark);
      }
    } else if (params.options.CarPark) {
      this.loadCarParkData(params.googleMap);
    }
  }

  // loadCar park data;
  public loadCarParkData = (googleMap: IGoogleMap): void => {
    this.googleHttp.getParkingData(this.getBoundinBoxData(googleMap)).subscribe(data => {
      this.carParkData = data;
      this.addCarkParkMarker(googleMap);
    },
      error => { console.log(error); }
    );
  }

  public clearAll() {
    this.carParkMarker.forEach(marker => {
      marker.setMap(null);
    });
    this.carParkMarker = [];
  }

  private addCarkParkMarker = (googleMap: IGoogleMap) => {

    this.clearAll();

    for (let markerCounter = 0; markerCounter < this.carParkData.length; markerCounter++) {
      const carParkModel: ITrafficAlertCarkPark = this.carParkData[markerCounter];

      const dummyMarkerCount: number = carParkModel.hitCount - carParkModel.topHits.length;
      if (dummyMarkerCount > 0) {
        const marker = this.aaMarkerService.createClusterMarker(googleMap, carParkModel, carParkModel.hitCount, AAClusterType.CAR_PARK_CLUSTER);
        this.carParkMarker.push(marker);
      } else {
        for (let tophitCounter = 0; tophitCounter < carParkModel.topHits.length; tophitCounter++) {
          const topHitModel: CarParkTopHits = carParkModel.topHits[tophitCounter] as CarParkTopHits;
          this.createCarParkMarker(topHitModel, googleMap);
        }
      }
    }
  }

  private createCarParkMarker = (markerDataObj: CarParkTopHits, googleMap: IGoogleMap) => {
    const icon: MarkerIcon = this.googleIconManager.getCarParkIcon();

    const cpShape = {
      coord: [1, 1, 1, 30, 28, 30, 28, 1],
      type: 'poly'
    };

    const latLng: ILatLng = new google.maps.LatLng(markerDataObj.lat, markerDataObj.lon);
    const cpMarker = new google.maps.Marker({
      position: new google.maps.LatLng(markerDataObj.lat, markerDataObj.lon),
      map: googleMap,
      icon: icon,
      title: markerDataObj.operator || 'Car Park',
      shape: cpShape,
      // shadow: IconShadow,
      html: this.mapsWrapper.getCarParkMarkerInfoWindowHtmlContent(markerDataObj)
    });

    cpMarker.category = 'carpark';
    cpMarker.data = markerDataObj;
    // cpMarker.setVisible(this.googleMapOptions.CarPark);

    google.maps.event.addListener(cpMarker, 'click', () => {
      this.googleInfoWindow.close();
      this.googleInfoWindow.setContent(cpMarker.html);
      this.googleInfoWindow.open(googleMap, cpMarker);
    });
    this.carParkMarker.push(cpMarker);

    return cpMarker;
  }

}
